export default __webpack_public_path__ + "static/media/bootstrap-icons.c1dcd4ee.woff2";